import { hasTracking } from "@escapio/shared/state/client-settings";
import { hasAllPurposesConsent } from "@escapio/shared/tracker/ConsentObserver";

customElements.define(
	"esc-google-adwords-loader",
	class extends HTMLElement {
		connectedCallback() {
			if (!hasTracking) return;
			hasAllPurposesConsent.then(this.load.bind(this));
		}

		load() {
			const script = document.createElement("script");
			script.async = true;
			script.src = `https://www.googletagmanager.com/gtag/js?id=${this.adwordsConversionId}`;
			script.type = "text/javascript";
			document.head.appendChild(script);

			window.gtag("js", new Date());
			window.gtag("config", this.adwordsConversionId);
			window.gtag("consent", "update", { ad_storage: "granted" });
		}

		get adwordsConversionId() {
			return this.getAttribute("adwords-conversion-id");
		}
	},
);
